// extracted by mini-css-extract-plugin
export default {"error-box":"style_error-box__QsWvk","error-img":"style_error-img__dWY4M","error-text":"style_error-text__E58Rq","error-action":"style_error-action__s3FEB"};